import { FC, useCallback, useEffect, useMemo, useRef, useState } from 'react';
import {FlexBox, NeutralLink, ShowMoreButton} from '@brg/ui';
import { Tag } from '@brg/api';
import {
    TagsSearchInput,
    TagsSearchInputWrapper,
    TagsShadow}
from './styles';
import { useTheme } from 'styled-components';
import { BTag } from '../../../core/components';
import { bTag, useModal } from "../../../core";
import ReactTooltip from "react-tooltip";
import { TagsSearchBar } from 'core/components/bTag/styles';
import SearchIcon16 from 'shared/icons/SearchIcon16';
import { debounceEvent } from 'shared/utils/debounce';
import { useTranslation } from 'react-i18next';
import { LOAD_TYPE } from './selectTagsModal';
import { AddTagField } from './AddTagField';
import FoundChildrens from './FoundedChildrens';
import { ITagsProps } from 'shared/hooks/api/useTagsList';
import { isRequired } from './support/isRequired';
import { useRouteMatch } from 'react-router-dom';

const EDUCATION_CATEGORY_ID = 'c326e5a4bd0b02c9c338fe382ac1f9a8';
export const CITIES_CATEGORY_ID = 'dc762a78dac54369b91542bcbe86bb2a';

export enum TAGS_LEVEL {
    child = 0,
    children = 1,
    parent = 2,
}

export interface TagsSearchResultsItemProps {
    title: string;
    identifier: string;
    items: Tag[];
    searchingIntoTag?: boolean;
    isCategoryTag?: boolean;
    isCategoryClickable?: boolean;
    isSelected: (id: string) => boolean;
    onClick: (tag: Tag, selected: boolean) => void;
    onParentClick?: (id: string) => void;
    onMoreClick?: (id: string) => void;
    onTagArrowClick?: (id: string, flag: boolean) => void;
    onSearchInputChange?: (e: any, id: string, loadT?: number) => void;
    onSearchIntoCategory?: (e: any) => void;
    onMoreLargeCategoryClick?: (e: any) => void;
    setHideMore?: (value: boolean) => void;
    hideMore?: boolean;
    isTagOpen?: boolean;
    setIsOpenTag?: Function;
    search: string;
    found: number;
    moreNeeded?: boolean;
    searchNeeded?: boolean;
    isCategorySearchNeed?: boolean;
    isEditPage?: boolean;
    loadType?: number
    tagsFilter?: ITagsProps;
    isEmptySearch?: boolean;
    setTime?: any;
    isGlobalSearch?: boolean;
    isShowAll?: boolean;
    isViewAllTagsMode?: boolean;
    isLinkMode?: boolean;
    isCreateLocationPage?: boolean;
    activeTagId?: string;
}

export const TagsSearchResultsItem: FC<TagsSearchResultsItemProps> = (props) => {
    const {
        identifier,
        items,
        isSelected,
        isCategoryClickable,
        onClick,
        onParentClick,
        onSearchInputChange,
        onSearchIntoCategory,
        onMoreClick,
        onTagArrowClick,
        isEmptySearch,
        isGlobalSearch,
        search,
        isCategorySearchNeed,
        isViewAllTagsMode,
        isEditPage,
        tagsFilter,
        isShowAll,
        isLinkMode,
        activeTagId,
        isCreateLocationPage,
        hideMore,
        setHideMore
     } = props;

    const [isOpen, setIsOpen] = useState(isCategoryClickable ? false : true);
    const { t } = useTranslation();
    const gridRef = useRef<any>();
    const theme = useTheme();
    const modal = useModal();
    
    useEffect(() => {
        setHideMore && setHideMore(false);
    }, [])

    const isShadow = useMemo(
        () => (gridRef.current ? gridRef.current.getBoundingClientRect().height > 70 : false),
        [gridRef],
    );
    //@ts-ignore
    const isNewTag = (items?.length === 1 && items[0].isNewTag) || false
    const isTeamEdit = !!useRouteMatch('/team-edit');

    const isEducationCategory = useMemo(
        () => (identifier === EDUCATION_CATEGORY_ID) , [identifier])

    const localSearchInputVisible = useMemo(
        () =>  (isCategorySearchNeed && !!onSearchIntoCategory && isOpen && !isGlobalSearch) 
    , [isCategorySearchNeed, isOpen, isGlobalSearch, onSearchIntoCategory])

    useEffect(() => {
        if (!items?.length || items.length > 120) return;
        const id = window.setTimeout(() => ReactTooltip.rebuild(), 0);
        return () => window.clearTimeout(id);
    }, [items, activeTagId])

    // @ts-ignore
    const categorySearchLocal = useCallback((tag) => (e: any) => {
        const vl = e.target.value
        onSearchInputChange && onSearchInputChange(
            e,
            vl ? tag?.tagId : undefined,
            vl ? LOAD_TYPE.tagsSearchIntoCategory : undefined
        );
    }, [onSearchInputChange])

    const memoGrids = useMemo(() => {

        return (
            <>
                {(isOpen ? items : []).map((tag: any) => {
                    const isTagHaveChild= isViewAllTagsMode ? false : (tag?.level === TAGS_LEVEL.children)
                    const isTagSelected = isSelected(tag?.tagId);
                    const isTagInSearch = bTag.title(tag)?.toLocaleLowerCase()?.includes(search?.toLocaleLowerCase());
                    const isCanAddNewTag = isEmptySearch && tag?.typeCategory === 'open';
                    const currentActiveTag = activeTagId || '';
                    const tagIsOpen = currentActiveTag === tag?.tagId;
                    const isTagsShadowNeed = !!currentActiveTag && !tagIsOpen;

                    return (
                        <>
                        {isTagHaveChild ? (
                            <FoundChildrens
                                item={tag}
                                search={search}
                                secondary={search !== '' && !isTagInSearch}
                                selected={isSelected}
                                parent={isTagHaveChild}
                                children_item={tag?.additionalTags}
                                isTagOpen={tag?.isChildrenVisible}
                                onClick={onClick}
                                onParentClick={(!isEditPage && onParentClick) ? () => {
                                    onParentClick(tag?.tagId) ;
                                } : () => false}
                                onMoreClick={() => {
                                    onMoreClick && onMoreClick(tag?.tagId);
                                }}
                                onTagArrowClick={() => {
                                    onTagArrowClick && onTagArrowClick(tag?.tagId, !tag?.isChildrenVisible);
                                }}
                                onSearchInputChange={(e) => {
                                    onSearchInputChange && onSearchInputChange(e, tag?.tagId);
                                }}
                                onSearchIntoCategory={ // * обработчик для создания тега
                                    categorySearchLocal(tag)
                                }
                                isEmptySearch={isCanAddNewTag}  // признак для добавления тега
                                key={tag?.tagId}
                                opacity={isTagsShadowNeed}
                                moreNeeded={tag?.isMoreButton}
                                tagsFilter={tagsFilter}
                                canOpenTag={tagIsOpen}
                                {...isGlobalSearch ? {} : { searchNeeded: tag?.isSearchButton}}
                                isLinkMode={isLinkMode}
                            />
                        ) : (
                            <BTag
                                tag={tag}
                                secondary={search !== '' && !isTagInSearch}
                                removable={isTagSelected}
                                selected={isTagSelected}
                                parent={isTagHaveChild}
                                educational={isRequired(tag)}
                                organization={tag?.isTeamTag}
                                onClick={() => {
                                onClick(tag, isTagSelected)
                                }}
                                key={tag.tagId}
                                opacity={isTagsShadowNeed}
                                isRequired={isRequired(tag)}
                                isEducationCategory={isEducationCategory}
                                hasLink={isLinkMode}
                            >
                                {bTag.title(tag)}
                            </BTag>
                        )}
                        </>
                    );
                })}
                {!isOpen && isShadow && <TagsShadow />}
                {isShowAll && (
                    <>
                        {isEditPage ? (
                            <ShowMoreButton
                                onClick={() => {
                                    onMoreClick && onMoreClick(identifier)
                                    setHideMore && setHideMore(true);
                                }}
                                showLess={hideMore}
                                style={{ visibility: hideMore ? 'hidden' : 'visible' }}
                            >{t("tags_button_more")}</ShowMoreButton>
                        ) : (
                            <NeutralLink to={`/tag/category/${identifier}`}
                                style={{ display: 'inline-flex', width: 'max-content' }}
                                onClick={() => modal.hide()}
                            >
                                <ShowMoreButton
                                    external
                                >{t("tags_button_more")}</ShowMoreButton>
                            </NeutralLink>
                        )}
                    </>
                )}
            </>
        );
    }, [isOpen, items, isViewAllTagsMode, activeTagId, isGlobalSearch, isShadow, isShowAll, isTeamEdit, isEditPage, identifier, t, isSelected, search, isEmptySearch, tagsFilter, onClick, onParentClick, categorySearchLocal, onMoreClick, onTagArrowClick, onSearchInputChange, modal]);

    if (!items?.length) {
        return null;
    }
    if (isCreateLocationPage) {
        return (
            <>
                {localSearchInputVisible && (
                    <FlexBox style={{ position: 'relative' }} width={'1152px'} widthMobile={'100%'} directionMobile={'column'} direction={'column'}>
                        <TagsSearchInputWrapper offsetBottom={8} offsetBottomMobile={12} /*offsetTop={15}*/>
                            <SearchIcon16 fill={theme.tags.modal.search.color} />
                            <TagsSearchInput
                                onInput={onSearchIntoCategory && debounceEvent(onSearchIntoCategory, 500)}
                                placeholder={t('tags_modal.search_into_tag')}
                                style={{marginLeft: '12px'}}
                            />
                        </TagsSearchInputWrapper>
                    </FlexBox>
                )}
    
                {
                    !isNewTag
                        ? memoGrids
                        : <AddTagField
                            //@ts-ignore
                            parentTag={items[0].parentTag}
                            name={items[0].name}
                        />
    
                }
            </>
        );
    }
    
    return (
        <>
            {localSearchInputVisible && false && (
                <FlexBox style={{ position: 'relative' }} width={'100%'} directionMobile={'column'} direction={'column'}>
                    <TagsSearchBar static offsetBottom={8} offsetBottomMobile={12} /*offsetTop={15}*/>
                        <SearchIcon16 fill={theme.tags.modal.search.color} />
                        <TagsSearchInput
                            // @ts-ignore
                            onInput={onSearchIntoCategory && debounceEvent(onSearchIntoCategory, 500)}
                            placeholder={t('tags_modal.search_into_tag')}
                        />
                    </TagsSearchBar>
                </FlexBox>
            )}

            {
                !isNewTag
                    ? memoGrids
                    : <AddTagField
                        //@ts-ignore
                        parentTag={items[0].parentTag}
                        name={items[0].name}
                    />

            }
        </>
    );
};
import { FC, useCallback, useEffect, useMemo, useRef, useState } from 'react';
import {FlexBox, NeutralLink, ShowMoreButton} from '@brg/ui';
import { Tag } from '@brg/api';
import {
    TagsSearchInput,
    TagsSearchInputWrapper,
    TagsShadow}
from './styles';
import { useTheme } from 'styled-components';
import { BTag } from '../../../core/components';
import { bTag, useModal } from "../../../core";
import ReactTooltip from "react-tooltip";
import { TagsSearchBar } from 'core/components/bTag/styles';
import SearchIcon16 from 'shared/icons/SearchIcon16';
import { debounceEvent } from 'shared/utils/debounce';
import { useTranslation } from 'react-i18next';
import { LOAD_TYPE } from './selectTagsModal';
import { AddTagField } from './AddTagField';
import FoundChildrens from './FoundedChildrens';
import { ITagsProps } from 'shared/hooks/api/useTagsList';
import { isRequired } from './support/isRequired';
import { useRouteMatch } from 'react-router-dom';

const EDUCATION_CATEGORY_ID = 'c326e5a4bd0b02c9c338fe382ac1f9a8';
export const CITIES_CATEGORY_ID = 'dc762a78dac54369b91542bcbe86bb2a';

export enum TAGS_LEVEL {
    child = 0,
    children = 1,
    parent = 2,
}

export interface TagsSearchResultsItemProps {
    title: string;
    identifier: string;
    items: Tag[];
    searchingIntoTag?: boolean;
    isCategoryTag?: boolean;
    isCategoryClickable?: boolean;
    isSelected: (id: string) => boolean;
    onClick: (tag: Tag, selected: boolean) => void;
    onParentClick?: (id: string) => void;
    onMoreClick?: (id: string) => void;
    onTagArrowClick?: (id: string, flag: boolean) => void;
    onSearchInputChange?: (e: any, id: string, loadT?: number) => void;
    onSearchIntoCategory?: (e: any) => void;
    onMoreLargeCategoryClick?: (e: any) => void;
    setHideMore?: (value: boolean) => void;
    hideMore?: boolean;
    isTagOpen?: boolean;
    setIsOpenTag?: Function;
    search: string;
    found: number;
    moreNeeded?: boolean;
    searchNeeded?: boolean;
    isCategorySearchNeed?: boolean;
    isEditPage?: boolean;
    loadType?: number
    tagsFilter?: ITagsProps;
    isEmptySearch?: boolean;
    setTime?: any;
    isGlobalSearch?: boolean;
    isShowAll?: boolean;
    isViewAllTagsMode?: boolean;
    isLinkMode?: boolean;
    isCreateLocationPage?: boolean;
    activeTagId?: string;
}

export const TagsSearchResultsItem: FC<TagsSearchResultsItemProps> = (props) => {
    const {
        identifier,
        items,
        isSelected,
        isCategoryClickable,
        onClick,
        onParentClick,
        onSearchInputChange,
        onSearchIntoCategory,
        onMoreClick,
        onTagArrowClick,
        isEmptySearch,
        isGlobalSearch,
        search,
        isCategorySearchNeed,
        isViewAllTagsMode,
        isEditPage,
        tagsFilter,
        isShowAll,
        isLinkMode,
        activeTagId,
        isCreateLocationPage,
        hideMore,
        setHideMore
     } = props;

    const [isOpen, setIsOpen] = useState(isCategoryClickable ? false : true);
    const { t } = useTranslation();
    const gridRef = useRef<any>();
    const theme = useTheme();
    const modal = useModal();
    
    useEffect(() => {
        setHideMore && setHideMore(false);
    }, [])

    const isShadow = useMemo(
        () => (gridRef.current ? gridRef.current.getBoundingClientRect().height > 70 : false),
        [gridRef],
    );
    //@ts-ignore
    const isNewTag = (items?.length === 1 && items[0].isNewTag) || false
    const isTeamEdit = !!useRouteMatch('/team-edit');

    const isEducationCategory = useMemo(
        () => (identifier === EDUCATION_CATEGORY_ID) , [identifier])

    const localSearchInputVisible = useMemo(
        () =>  (isCategorySearchNeed && !!onSearchIntoCategory && isOpen && !isGlobalSearch) 
    , [isCategorySearchNeed, isOpen, isGlobalSearch, onSearchIntoCategory])

    useEffect(() => {
        if (!items?.length || items.length > 120) return;
        const id = window.setTimeout(() => ReactTooltip.rebuild(), 0);
        return () => window.clearTimeout(id);
    }, [items, activeTagId])

    // @ts-ignore
    const categorySearchLocal = useCallback((tag) => (e: any) => {
        const vl = e.target.value
        onSearchInputChange && onSearchInputChange(
            e,
            vl ? tag?.tagId : undefined,
            vl ? LOAD_TYPE.tagsSearchIntoCategory : undefined
        );
    }, [onSearchInputChange])

    const memoGrids = useMemo(() => {

        return (
            <>
                {(isOpen ? items : []).map((tag: any) => {
                    const isTagHaveChild= isViewAllTagsMode ? false : (tag?.level === TAGS_LEVEL.children)
                    const isTagSelected = isSelected(tag?.tagId);
                    const isTagInSearch = bTag.title(tag)?.toLocaleLowerCase()?.includes(search?.toLocaleLowerCase());
                    const isCanAddNewTag = isEmptySearch && tag?.typeCategory === 'open';
                    const currentActiveTag = activeTagId || '';
                    const tagIsOpen = currentActiveTag === tag?.tagId;
                    const isTagsShadowNeed = !!currentActiveTag && !tagIsOpen;

                    return (
                        <>
                        {isTagHaveChild ? (
                            <FoundChildrens
                                item={tag}
                                search={search}
                                secondary={search !== '' && !isTagInSearch}
                                selected={isSelected}
                                parent={isTagHaveChild}
                                children_item={tag?.additionalTags}
                                isTagOpen={tag?.isChildrenVisible}
                                onClick={onClick}
                                onParentClick={(!isEditPage && onParentClick) ? () => {
                                    onParentClick(tag?.tagId) ;
                                } : () => false}
                                onMoreClick={() => {
                                    onMoreClick && onMoreClick(tag?.tagId);
                                }}
                                onTagArrowClick={() => {
                                    onTagArrowClick && onTagArrowClick(tag?.tagId, !tag?.isChildrenVisible);
                                }}
                                onSearchInputChange={(e) => {
                                    onSearchInputChange && onSearchInputChange(e, tag?.tagId);
                                }}
                                onSearchIntoCategory={ // * обработчик для создания тега
                                    categorySearchLocal(tag)
                                }
                                isEmptySearch={isCanAddNewTag}  // признак для добавления тега
                                key={tag?.tagId}
                                opacity={isTagsShadowNeed}
                                moreNeeded={tag?.isMoreButton}
                                tagsFilter={tagsFilter}
                                canOpenTag={tagIsOpen}
                                {...isGlobalSearch ? {} : { searchNeeded: tag?.isSearchButton}}
                                isLinkMode={isLinkMode}
                            />
                        ) : (
                            <BTag
                                tag={tag}
                                secondary={search !== '' && !isTagInSearch}
                                removable={isTagSelected}
                                selected={isTagSelected}
                                parent={isTagHaveChild}
                                educational={isRequired(tag)}
                                organization={tag?.isTeamTag}
                                onClick={() => {
                                onClick(tag, isTagSelected)
                                }}
                                key={tag.tagId}
                                opacity={isTagsShadowNeed}
                                isRequired={isRequired(tag)}
                                isEducationCategory={isEducationCategory}
                                hasLink={isLinkMode}
                            >
                                {bTag.title(tag)}
                            </BTag>
                        )}
                        </>
                    );
                })}
                {!isOpen && isShadow && <TagsShadow />}
                {isShowAll && (
                    <>
                        {isEditPage ? (
                            <ShowMoreButton
                                onClick={() => {
                                    onMoreClick && onMoreClick(identifier)
                                    setHideMore && setHideMore(true);
                                }}
                                showLess={hideMore}
                                style={{ visibility: hideMore ? 'hidden' : 'visible' }}
                            >{t("tags_button_more")}</ShowMoreButton>
                        ) : (
                            <NeutralLink to={`/tag/category/${identifier}`}
                                style={{ display: 'inline-flex', width: 'max-content' }}
                                onClick={() => modal.hide()}
                            >
                                <ShowMoreButton
                                    external
                                >{t("tags_button_more")}</ShowMoreButton>
                            </NeutralLink>
                        )}
                    </>
                )}
            </>
        );
    }, [isOpen, items, isViewAllTagsMode, activeTagId, isGlobalSearch, isShadow, isShowAll, isTeamEdit, isEditPage, identifier, t, isSelected, search, isEmptySearch, tagsFilter, onClick, onParentClick, categorySearchLocal, onMoreClick, onTagArrowClick, onSearchInputChange, modal]);

    if (!items?.length) {
        return null;
    }
    if (isCreateLocationPage) {
        return (
            <>
                {localSearchInputVisible && (
                    <FlexBox style={{ position: 'relative' }} width={'1152px'} widthMobile={'100%'} directionMobile={'column'} direction={'column'}>
                        <TagsSearchInputWrapper offsetBottom={8} offsetBottomMobile={12} /*offsetTop={15}*/>
                            <SearchIcon16 fill={theme.tags.modal.search.color} />
                            <TagsSearchInput
                                onInput={onSearchIntoCategory && debounceEvent(onSearchIntoCategory, 500)}
                                placeholder={t('tags_modal.search_into_tag')}
                                style={{marginLeft: '12px'}}
                            />
                        </TagsSearchInputWrapper>
                    </FlexBox>
                )}
    
                {
                    !isNewTag
                        ? memoGrids
                        : <AddTagField
                            //@ts-ignore
                            parentTag={items[0].parentTag}
                            name={items[0].name}
                        />
    
                }
            </>
        );
    }
    
    return (
        <>
            {localSearchInputVisible && false && (
                <FlexBox style={{ position: 'relative' }} width={'100%'} directionMobile={'column'} direction={'column'}>
                    <TagsSearchBar static offsetBottom={8} offsetBottomMobile={12} /*offsetTop={15}*/>
                        <SearchIcon16 fill={theme.tags.modal.search.color} />
                        <TagsSearchInput
                            // @ts-ignore
                            onInput={onSearchIntoCategory && debounceEvent(onSearchIntoCategory, 500)}
                            placeholder={t('tags_modal.search_into_tag')}
                        />
                    </TagsSearchBar>
                </FlexBox>
            )}

            {
                !isNewTag
                    ? memoGrids
                    : <AddTagField
                        //@ts-ignore
                        parentTag={items[0].parentTag}
                        name={items[0].name}
                    />

            }
        </>
    );
};
